import React from "react";
import { useMediaQuery } from "react-responsive";
import Carousel from "../../../components/Carousel";
import PCHeader from "../../../components/PCHeader";
import TabletHeader from "../../../components/TabletHeader";
import YoutubeSection from "../../../components/YoutubeSection";
import "./style.scss";

const MainPage = () => {
  const isTablet = useMediaQuery({
    query: "(min-width:650px) and (max-width:1450px)",
  });
  return (
    <div>
      {isTablet ? <TabletHeader /> : <PCHeader />}
      <section>
        {/* <img id="01" className="imgs" src="/img/pages/pc-slide-0.png" /> */}
        
        <Carousel device="pc" />

        <YoutubeSection device={isTablet ? "mobile" : "pc"} />
        <img id="02" className="imgs" src="/img/pages/pc-10.jpg" />
        <img id="03" className="imgs" src="/img/pages/pc-11.jpg" />
        <img id="04" className="imgs" src="/img/pages/pc-12.jpg" />
        <img id="05" className="imgs" src="/img/pages/pc-13.jpg" />
        <img id="06" className="imgs" src="/img/pages/pc-15.jpg" />
        <img className="imgs" src="/img/pages/pc-16.jpg" />
        <img className="imgs" src="/img/pages/pc-17.jpg" />
      </section>
      <footer className="pc-footer-cn">
        <div className="logo-cn">
          <img className="footer-log" src="/img/footer_logo@2x.png" />
        </div>
        <div>
          <p>
            <span>상호명</span>바른정플란트치과의원 북구화명점
          </p>
          <p>
            <span>대표</span>김형우
          </p>
          <p>
            <span>사업자등록번호</span>606-39-04901
          </p>
        </div>
        <div>
          <p>
            <span>주소</span>부산 북구 금곡대로 199번길3, 화명메디칼빌딩 5층
          </p>
        </div>
        <div>
          <p>
            <span>전화번호</span>051-365-2275
          </p>
          <p>CopyrightⓒBARENJUNGPLANT Rights Reserved.</p>
          <div
            className="pc-fee-cn"
            onClick={() => {
              window.open(
                "https://blog.naver.com/3652275/222424577668",
                "_blank"
              );
            }}
          >
            <p>비급여수가표 바로가기</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MainPage;
